import { render, staticRenderFns } from "./BtnImportarSubItens.vue?vue&type=template&id=2716f931&"
import script from "./BtnImportarSubItens.vue?vue&type=script&lang=js&"
export * from "./BtnImportarSubItens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports